import React from 'react';
import SignUp from '../components/new-signup/SignUp';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PK || '');

const SignupPage = () => {

  return <Elements stripe={stripePromise}>
    <SignUp />
  </Elements>
};

export default SignupPage;
